module.exports = __webpack_public_path__ + "static/media/teams_logo.80ccd59e.svg";